import React from 'react';

const FileSourceContext = React.createContext();

export default FileSourceContext;
